var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 14.5,
    fill: "#455DDC",
    stroke: "#566DEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5452 15.2595C17.0985 16.7062 16.2857 18.6683 16.2857 20.7143V28.4286H31.7143V20.7143C31.7143 18.6683 30.9015 16.7062 29.4548 15.2595C28.0081 13.8128 26.046 13 24 13C21.954 13 19.9919 13.8128 18.5452 15.2595ZM15 30.3571V32.9286H33V30.3571H15ZM24.6104 15.0061C24.0615 14.9451 23.5671 15.3407 23.5061 15.8896C23.4451 16.4385 23.8407 16.9329 24.3896 16.9939C24.936 17.0546 25.8454 17.3664 26.6086 18.1228C27.3448 18.8524 28 20.0496 28 22C28 22.5523 28.4477 23 29 23C29.5523 23 30 22.5523 30 22C30 19.5504 29.1552 17.8309 28.0164 16.7022C26.9046 15.6003 25.564 15.1121 24.6104 15.0061Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventOn);
export default __webpack_public_path__ + "static/media/event_on.add112b821a212ee099f71be11e52d58.svg";
export { ForwardRef as ReactComponent };